export const isChunkLoadError = error => {
  if (!error) return false;

  const message = (error.message || "")?.toLowerCase();

  return (
    (error?.name || "")?.toLowerCase() === "chunkloaderror" ||
    message.includes("loading chunk") ||
    message.includes("failed to fetch dynamically imported module") ||
    message.includes("failed to execute 'removechild' on 'node'") ||
    message.includes("dynamically imported module")
  );
};
